import type { ClientOperatingContextListView, ClientOperatingContextSummary } from "@solomon-apps/shared";

import { orgApiFetch } from "./orgApiFetch";

const BASE = "/api/org/client/contexts";

function isClientOperatingContextSummary(value: unknown): value is ClientOperatingContextSummary {
    if (!value || typeof value !== "object") {
        return false;
    }

    const context = value as Partial<ClientOperatingContextSummary>;
    return (
        typeof context.issuerClientUuid === "string" &&
        typeof context.issuerOrganizationUuid === "string" &&
        typeof context.issuerOrganizationName === "string" &&
        (context.issuerCapabilityStatus === "Active" || context.issuerCapabilityStatus === "Suspended") &&
        (context.status === "Pending" ||
            context.status === "Active" ||
            context.status === "Suspended" ||
            context.status === "Cancelled") &&
        typeof context.defaultable === "boolean" &&
        typeof context.readOnly === "boolean" &&
        (context.readOnlyReason === null ||
            context.readOnlyReason === "IssuerCapabilitySuspended" ||
            context.readOnlyReason === "IssuerClientSuspended" ||
            context.readOnlyReason === "IssuerClientCancelled") &&
        typeof context.isSelfClient === "boolean" &&
        (context.distributionsAccess === undefined || typeof context.distributionsAccess === "boolean") &&
        (context.apiAccess === undefined || typeof context.apiAccess === "boolean") &&
        (context.platformAccessState === undefined ||
            context.platformAccessState === "Active" ||
            context.platformAccessState === "Paused" ||
            context.platformAccessState === "Revoked") &&
        (context.platformEligibility === undefined ||
            context.platformEligibility === "not_eligible" ||
            context.platformEligibility === "onboarding" ||
            context.platformEligibility === "eligible")
    );
}

export function normalizeClientOperatingContexts(
    input: Partial<ClientOperatingContextListView> | null | undefined
): ClientOperatingContextListView {
    const contexts = Array.isArray(input?.contexts) ? input.contexts.filter(isClientOperatingContextSummary) : [];
    const defaultClientContextUuid =
        typeof input?.defaultContextUuid === "string" &&
        contexts.some((context) => context.issuerClientUuid === input.defaultContextUuid)
            ? input.defaultContextUuid
            : null;

    return {
        contexts,
        defaultContextUuid: defaultClientContextUuid
    };
}

export async function listClientOperatingContexts(): Promise<ClientOperatingContextListView> {
    const response = await orgApiFetch<Partial<ClientOperatingContextListView>>(BASE);
    return normalizeClientOperatingContexts(response);
}
